<template>
    <div class="bg-white p-8 md:p-16 rounded shadow-md z-30">
        <div class="flex md:flex-row flex-col justify-between mb-6 gap-8">
            <h2 class="text-f4 font-bold">
                {{ searchTitle }}
            </h2>
            <div class="">
                <button
                    @click="
                        isLoggedIn
                            ? overlaysSvc.showOverlay('thpOrder')
                            : overlaysSvc.showOverlay('loginForm')
                    "
                    class="btn-cb"
                >
                    {{ freeTextOrderButtonText }}
                    <i class="fas fa-arrow-right"></i>
                </button>
            </div>
        </div>
        <div class="">
            <form @submit.prevent="onSubmit">
                <div class="">
                    <div class="relative mt-12">
                        <input
                            type="text"
                            :placeholder="searchPlaceholder"
                            class="!px-5 !py-3 w-full bg-grey-50 rounded-s input-text-input"
                            v-model="searchTerm"
                            @input="onInput"
                            autofocus
                        />
                        <div
                            v-if="
                                !preventDropdownReopen &&
                                showSuggestions &&
                                suggestions.length
                            "
                            v-click-outside="hideSuggestions"
                            class="absolute bg-white shadow rounded mt-2 w-full z-10 p-4"
                        >
                            <ul class="scroll-bar max-h-80" @scroll="onScroll">
                                <li
                                    v-for="(suggestion, index) in suggestions"
                                    :key="index"
                                    class="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                    @mousedown.prevent="
                                        selectSuggestion(suggestion)
                                    "
                                >
                                    {{ suggestion }}
                                </li>
                            </ul>
                        </div>

                        <button
                            type="submit"
                            class="absolute right-4 top-1/2 -translate-y-1/2"
                        >
                            <i class="fas fa-search"></i>
                        </button>
                    </div>
                    <div class="flex items-center gap-2 mt-4">
                        <label for="exact-cas-toggle" class="text-f7"
                            >Search exact CAS-Number</label
                        >
                        <input
                            id="exact-cas-toggle"
                            type="checkbox"
                            :value="exactCas"
                            class="toggle-checkbox"
                            @change="onExactCasToggle"
                        />
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { vClickOutside } from "../../directives/v-click-outside";

export default {
    props: {
        modelValue: {
            type: String,
            default: "",
        },
        suggestions: {
            type: Array,
            default: () => [], // Ensure suggestions is always an array
        },
        searchTitle: {
            type: String,
            default: "Find the items you want from our range",
        },
        searchPlaceholder: {
            type: String,
            default:
                "Please enter the desired search term, item number, or brand name...",
        },
        freeTextOrderButtonText: {
            type: String,
            default: "Create free text orders",
        },
        exactCas: {
            type: Boolean,
            default: false,
        },
    },
    directives: {
        clickOutside: vClickOutside,
    },
    emits: [
        "update:modelValue",
        "update:exactCas",
        "input",
        "submit",
        "scroll-down",
    ],
    inject: ["overlaysSvc", "cartSvc"],
    data() {
        return {
            searchTerm: this.modelValue || "",
            showSuggestions: false,
            preventDropdownReopen: false,
            isLoggedIn: this.cartSvc.isUserLoggedIn(),
        };
    },
    watch: {
        suggestions(newSuggestions) {
            if (!this.preventDropdownReopen) {
                this.showSuggestions = newSuggestions.length > 0;
            }
        },
        modelValue(newValue) {
            this.searchTerm = newValue;
        },
        exactCas(newValue) {
            console.log("Exact CAS changed to:", newValue);

            // make sure the checkbox reflects the prop change
            const checkbox = document.getElementById("exact-cas-toggle");
            if (checkbox) {
                checkbox.checked = newValue;
            }
        },
    },
    methods: {
        onInput(event) {
            this.preventDropdownReopen = false;

            this.$emit("input", this.searchTerm);
        },
        selectSuggestion(suggestion) {
            this.searchTerm = suggestion;
            this.showSuggestions = false;
            this.preventDropdownReopen = true; // Prevent reopening until the user types again

            this.$emit("update:exactCas", false);
            this.$emit("update:modelValue", suggestion);

            this.$emit("update:modelValue", suggestion);
            this.$emit("submit", {
                searchTerm: suggestion,
                exactCas: false, // Include the toggle state
                shouldScrollToResults: true, // Indicate that we want to scroll to results
            });
        },
        hideSuggestions() {
            this.showSuggestions = false;
        },
        onSubmit(event) {
            this.showSuggestions = false;
            this.preventDropdownReopen = true;
            this.$emit("update:modelValue", this.searchTerm);
            this.$emit("submit", {
                searchTerm: this.searchTerm,
                exactCas: this.exactCas, // Include the toggle state
                shouldScrollToResults: true, // Indicate that we want to scroll to results
            });
        },
        onExactCasToggle(event) {
            this.$emit("update:exactCas", event.target.checked);

            this.$emit("submit", {
                searchTerm: this.searchTerm,
                shouldScrollToResults: false,
            });
        },
        onScroll(event) {
            const { scrollTop, scrollHeight, clientHeight } = event.target;
            if (scrollTop + clientHeight >= scrollHeight) {
                this.$emit("scroll-down", this.searchTerm);
            }
        },
    },
};
</script>
